import { DeliverySelector } from "types/deliverySelector"
import { create } from "zustand"

export const useDeliverySelector = create<DeliverySelector>((set) => ({
  address: undefined,
  setAddress: (addressToSelect) => set(() => ({ address: addressToSelect })),
  removeAddress: () => set(() => ({ address: undefined })),
}))
